import React, { useState } from 'react';
import { Card, Select, Table, Button, Form, DatePicker, Radio, Input, message, Space, Row, Col } from 'antd';
import { CheckOutlined, CloseOutlined, SaveOutlined, UserOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import './styles.css';

const CoachAttendance = () => {
  const [form] = Form.useForm();
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMobile] = useState(window.innerWidth <= 768);

  // Örnek veri - normalde API'den gelecek
  const groups = [
    { id: 1, name: 'U-12 Futbol A' },
    { id: 2, name: 'U-14 Futbol B' },
    { id: 3, name: 'U-16 Basketbol' },
  ];

  const students = {
    1: [
      { id: 1, name: 'Ahmet Yılmaz' },
      { id: 2, name: 'Mehmet Demir' },
      { id: 3, name: 'Ayşe Kaya' },
    ],
    2: [
      { id: 4, name: 'Ali Öztürk' },
      { id: 5, name: 'Zeynep Çelik' },
    ],
    3: [
      { id: 6, name: 'Can Yıldız' },
      { id: 7, name: 'Ece Şahin' },
    ],
  };

  const mobileColumns = [
    {
      title: 'Öğrenci',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <Card className="student-card" size="small">
          <Row align="middle" gutter={[8, 8]}>
            <Col span={24}>
              <div className="student-name">
                <UserOutlined /> {text}
              </div>
            </Col>
            <Col span={24}>
              <Radio.Group
                value={record.status}
                onChange={(e) => handleStatusChange(record.id, e.target.value)}
                className="status-buttons"
              >
                <Radio.Button 
                  value="present" 
                  className={record.status === 'present' ? 'present' : ''}
                >
                  <CheckOutlined /> Var
                </Radio.Button>
                <Radio.Button 
                  value="absent" 
                  className={record.status === 'absent' ? 'absent' : ''}
                >
                  <CloseOutlined /> Yok
                </Radio.Button>
              </Radio.Group>
            </Col>
          </Row>
        </Card>
      ),
    },
  ];

  const desktopColumns = [
    {
      title: 'Öğrenci',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Durum',
      dataIndex: 'status',
      key: 'status',
      render: (_, record) => (
        <Radio.Group
          value={record.status}
          onChange={(e) => handleStatusChange(record.id, e.target.value)}
        >
          <Radio.Button value="present" style={{ background: record.status === 'present' ? '#f6ffed' : '' }}>
            <CheckOutlined /> Var
          </Radio.Button>
          <Radio.Button value="absent" style={{ background: record.status === 'absent' ? '#fff1f0' : '' }}>
            <CloseOutlined /> Yok
          </Radio.Button>
        </Radio.Group>
      ),
    },
    {
      title: 'Not',
      dataIndex: 'note',
      key: 'note',
      render: (_, record) => (
        <Input
          placeholder="Not ekle"
          value={record.note}
          onChange={(e) => handleNoteChange(record.id, e.target.value)}
        />
      ),
    },
  ];

  const handleGroupChange = (value) => {
    setSelectedGroup(value);
    const groupStudents = students[value].map(student => ({
      ...student,
      status: 'present',
      note: '',
    }));
    setAttendanceData(groupStudents);
  };

  const handleStatusChange = (studentId, status) => {
    setAttendanceData(prev =>
      prev.map(student =>
        student.id === studentId ? { ...student, status } : student
      )
    );
  };

  const handleNoteChange = (studentId, note) => {
    setAttendanceData(prev =>
      prev.map(student =>
        student.id === studentId ? { ...student, note } : student
      )
    );
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      
      // API çağrısı simülasyonu
      setTimeout(() => {
        message.success('Yoklama başarıyla kaydedildi');
        setLoading(false);
      }, 1000);
    } catch (error) {
      message.error('Yoklama kaydedilemedi');
    }
  };

  const handleAllPresent = () => {
    setAttendanceData(prev =>
      prev.map(student => ({ ...student, status: 'present' }))
    );
  };

  return (
    <Card title="Yoklama Al" className="attendance-card">
      <Form form={form} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="group"
              label="Grup"
              rules={[{ required: true, message: 'Lütfen grup seçin' }]}
            >
              <Select
                placeholder="Grup seçin"
                onChange={handleGroupChange}
                options={groups.map(group => ({
                  value: group.id,
                  label: group.name,
                }))}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item
              name="date"
              label="Tarih"
              rules={[{ required: true, message: 'Lütfen tarih seçin' }]}
              initialValue={dayjs()}
            >
              <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8} lg={6}>
            <Form.Item label=" " style={{ marginBottom: 0 }}>
              <Button type="default" onClick={handleAllPresent} block>
                Tümü Var
              </Button>
            </Form.Item>
          </Col>
        </Row>

        {selectedGroup && (
          <>
            <div className="attendance-table">
              <Table
                columns={isMobile ? mobileColumns : desktopColumns}
                dataSource={attendanceData}
                rowKey="id"
                pagination={false}
                bordered={!isMobile}
                showHeader={!isMobile}
              />
            </div>

            <div className="submit-button">
              <Button
                type="primary"
                icon={<SaveOutlined />}
                onClick={handleSubmit}
                loading={loading}
                block
              >
                Yoklamayı Kaydet
              </Button>
            </div>
          </>
        )}
      </Form>
    </Card>
  );
};

export default CoachAttendance; 